// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"802577eb","79":"1267e7d3","513":"4fe5c0d8"}[chunkId] + ".chunk.js";
};